// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTeamsMultipleQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  selectedOptionsLike: Types.TeamWhereInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetTeamsMultipleQuery = { __typename?: 'Query', queryData: { __typename?: 'TeamConnection', totalCount: number, edges?: Array<{ __typename?: 'TeamEdge', node?: { __typename?: 'Team', id: string, workosDirectoryGroupID?: string | null, name: string } | null } | null> | null }, selectedData: { __typename?: 'TeamConnection', totalCount: number, edges?: Array<{ __typename?: 'TeamEdge', node?: { __typename?: 'Team', id: string, workosDirectoryGroupID?: string | null, name: string } | null } | null> | null } };

export const Operations = {
  Query: {
    GetTeamsMultiple: 'GetTeamsMultiple' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetTeamsMultipleDocument = gql`
    query GetTeamsMultiple($query: String, $selectedOptionsLike: TeamWhereInput!, $first: Int!) {
  queryData: teams(where: {nameContainsFold: $query}, first: $first) {
    totalCount
    edges {
      node {
        id
        workosDirectoryGroupID
        name
      }
    }
  }
  selectedData: teams(where: $selectedOptionsLike, first: $first) {
    totalCount
    edges {
      node {
        id
        workosDirectoryGroupID
        name
      }
    }
  }
}
    `;

/**
 * __useGetTeamsMultipleQuery__
 *
 * To run a query within a React component, call `useGetTeamsMultipleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsMultipleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsMultipleQuery({
 *   variables: {
 *      query: // value for 'query'
 *      selectedOptionsLike: // value for 'selectedOptionsLike'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetTeamsMultipleQuery(baseOptions: Apollo.QueryHookOptions<GetTeamsMultipleQuery, GetTeamsMultipleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsMultipleQuery, GetTeamsMultipleQueryVariables>(GetTeamsMultipleDocument, withFetchPolicyContext(options));
      }
export function useGetTeamsMultipleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsMultipleQuery, GetTeamsMultipleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsMultipleQuery, GetTeamsMultipleQueryVariables>(GetTeamsMultipleDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetTeamsMultipleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamsMultipleQuery, GetTeamsMultipleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamsMultipleQuery, GetTeamsMultipleQueryVariables>(GetTeamsMultipleDocument, withFetchPolicyContext(options));
        }
export type GetTeamsMultipleQueryHookResult = ReturnType<typeof useGetTeamsMultipleQuery>;
export type GetTeamsMultipleLazyQueryHookResult = ReturnType<typeof useGetTeamsMultipleLazyQuery>;
export type GetTeamsMultipleSuspenseQueryHookResult = ReturnType<typeof useGetTeamsMultipleSuspenseQuery>;
export type GetTeamsMultipleQueryResult = Apollo.QueryResult<GetTeamsMultipleQuery, GetTeamsMultipleQueryVariables>;